// extracted by mini-css-extract-plugin
export default {"editPenButton":"EditPenButton_editPenButton__zk3Pt"};